module.exports = __webpack_public_path__ + "img/StickerRegistration.3377c4db.png";